export const texts = {
  pageTitle: { es: "???", ch: "???" },
  header: { es: "???", ch: "???" },
  
  senoras : { es: "Señoras", ch: "女士" }, 
  caballeros : { es: "Caballeros", ch: "男士" }, 
  mujer : { es: "Señoras", ch: "女士" }, 
  hombre : { es: "Caballeros", ch: "男士" }, 
  
  /* prendas de mujer */
  mabrigo : { es: "Abrigo o gabardina", ch: "大衣，风衣" }, 
  malbornoz : { es: "Albornoz o bata", ch: "浴袍" }, 
  mblusapolo : { es: "Blusa o polo", ch: "衬衣，POLO衫" }, 
  mblusaseda : { es: "Blusa de seda", ch: "丝绸外衣" }, 
  mbraguita : { es: "Braguita", ch: "女士内衣" }, 
  mcombinación : { es: "Combinación", ch: "女士睡衣" }, 
  mchaqueta : { es: "Chaqueta", ch: "外套" }, 
  mfalda : { es: "Falda", ch: "裙子" }, 
  mjersey : { es: "Jersey", ch: "毛衣" }, 
  mleotardos : { es: "Leotardos ", ch: "丝袜" }, 
  mpantalón : { es: "Pantalón", ch: "长裤" }, 
  mpañuelo : { es: "Pañuelo ", ch: "围巾，披巾" }, 
  mpijama : { es: "Pijama ", ch: "睡衣(套)" }, 
  msujetador : { es: "Sujetador", ch: "胸衣" }, 
  mtraje : { es: "Traje de chaqueta ", ch: "套装" }, 
  mvestido : { es: "Vestido ", ch: "礼服长裙" }, 
  mvestidonoche : { es: "Vestido de noche  ", ch: "晚礼服" }, 

  /* prendas de hombre */
  
  habrigo : { es: "Abrigo ", ch: "大衣" }, 
  halbornoz : { es: "Albornoz o bata ", ch: "浴袍" }, 
  hamericana : { es: "Americana ", ch: "西服（美式）" }, 
  hcalcetines : { es: "Calcetines ", ch: "袜子" }, 
  hcalzoncillos : { es: "Calzoncillos", ch: "男士内衣" }, 
  hcamisetaetiq : { es: "Camiseta etiqueta ", ch: "衬衫" }, 
  hcamiseta : { es: "Camiseta ", ch: "T恤" }, 
  hcorbata : { es: "Corbata ", ch: "领带" }, 
  hchaleco : { es: "Chaleco ", ch: "马甲" }, 
  hjersey : { es: "Jersey", ch: "毛衣" }, 
  hpantalón : { es: "Pantalón", ch: "长裤" }, 
  hpanuelo : { es: "Pañuelo ", ch: "围巾" }, 
  hpijama : { es: "Pijama", ch: "睡衣(套)" }, 
  hsmoking : { es: "Smoking ", ch: "晚礼服（男）" }, 
  htraje : { es: "Traje completo (2 piezas) ", ch: "套装(二件)" }, 
  
  /* tipos de lavado */
  
  kind1 : { es: "Lavado y planchado", ch: "湿洗,净熨" }, 
  kind2 : { es: "Planchar solamente", ch: "净熨" }, 
  kind3 : { es: "Lavado en seco", ch: "干洗" }, 
  
  lavadoplan : { es: "Lavado y planchado", ch: "湿洗,净熨" }, 
  planchar : { es: "Planchar solamente", ch: "净熨" }, 
  lavadosec : { es: "Lavado en seco", ch: "干洗" }, 

  /* Cabeceras */
  
  articulos : { es: "Artículos", ch: "项目" }, 
  iva : { es: "+IVA", ch: "增值税价格" }, 
  neto : { es: "Neto", ch: "净值" }, 
  npiezas : { es: "Nº piezas", ch: "数量" }, 
  totalneto : { es: "Total neto", ch: "计数净值" }, 
  totaliva : { es: "Total+IVA", ch: "计数增值税价格" }, 
  
  nombre : { es: "Nombre:", ch: "姓名" }, 
  fecha : { es: "Fecha de entrega:", ch: "送回时间" }, 
  hora : { es: "Hora:", ch: "时间" }, 
  nhab : { es: "Nº habitación: ", ch: "房间号" }, 
  adevolver : { es: "A devolver: Hoy/mañana", ch: "送回: 今天/明天" }, 
  
  /* Textos de abajo */
  serviciofestivos : { es: "Servicio de lavado, planchado o tinte excepto domingos y festivos.", ch: "周日及节假日不提供洗衣熨烫及去除污渍服务。" }, 
  aviso : { es: "Aviso: tenga la bondad de cumplimentar la hoja indicando el número y clase de piezas entregadas.", ch: "请在单据上填写说明交付件的数量和种类。" }, 
  entregadapre10 : { es: "La ropa se entregada antes de las 10:00 se devolverá en el día sin recargo. ", ch: "上午10:00前送洗的衣物，可在当日送回，不加收额外费用。" }, 
  entregadapost10 : { es: "La roba recibida después de las 10:00 le será devuelta al día siguiente.", ch: "上午10:00后送洗的衣物，可在次日送回。" }, 
  entregada10a14 : { es: "La ropa entregada después de las 10:00 y antes de las 14 y que sea requerida para el mismo día, tendrá un recargo del 50%.", ch: "上午10:00后送洗的衣物，如需在当日14:00之前取回，需支付50%附加费用。" }, 
  responsabilidad : { es: "La responsabilidad del Hotel, en caso de pérdida o deterioro de una prenda, no podrá exceder de diez veces el precio que se cobra por el servicio.", ch: "如果由于酒店方责任造成的衣物丢失或损坏，其赔偿不超过洗烫费单价的10倍。" }, 
  prendasdobladas : { es: "Prendas dobladas ", ch: "服务包含折叠衣物" }, 
  prendascolgadas : { es: "Prendas colgadas", ch: "服务包含挂架衣物" }, 
  ivaincl : { es: "IVA incluido", ch: "价格包含增值税" }, 
  firmacliente : { es: "Firma del cliente", ch: "贵客签字" }, 
  total2 : { es: "Total", ch: "总计" }, 
}

export const prices = {
  mabrigo:          { lavadoplan: 13.64, planchar: 12.30, lavadosec: 19.52 },
  malbornoz:        { lavadoplan: 11.77, planchar: 9.09, lavadosec: null },
  mblusapolo:       { lavadoplan: 7.76, planchar: 5.88, lavadosec: 9.90 },
  mblusaseda:       { lavadoplan: 9.10, planchar: 6.69, lavadosec: 10.97 },
  
  mbraguita:        { lavadoplan: 3.74, planchar: null, lavadosec: null },
  mcombinación:     { lavadoplan: 616,  planchar: null, lavadosec: null },
  mchaqueta:        { lavadoplan: 990,  planchar: 776,  lavadosec: 1230 },
  mfalda:           { lavadoplan: 1043, planchar: 776,  lavadosec: 1097 },
  mjersey:          { lavadoplan: 775,  planchar: 536,  lavadosec: 910  },
  mleotardos:       { lavadoplan: 401,  planchar: null, lavadosec: null },
  mpantalón:        { lavadoplan: 1043, planchar: 776,  lavadosec: 1097 },
  mpañuelo:         { lavadoplan: 508,  planchar: 348,  lavadosec: 669  },
  mpijama:          { lavadoplan: 776,  planchar: 536,  lavadosec: null },
  msujetador:       { lavadoplan: 401,  planchar: null, lavadosec: null },
  mtraje:           { lavadoplan: 1498, planchar: 1177, lavadosec: 1952 },
  mvestido:         { lavadoplan: 1203, planchar: 910,  lavadosec: 1598 },
  mvestidonoche:    { lavadoplan: 1686, planchar: 1311, lavadosec: 1952 },
  
  habrigo:          { lavadoplan: 13.64, planchar: 12.30, lavadosec: 19.52 },
  halbornoz:        { lavadoplan: 11.77, planchar:  9.10, lavadosec: null  },
  hamericana:       { lavadoplan:  9.90, planchar:  7.76, lavadosec: 12.30 },
  hcalcetines:      { lavadoplan:  3.48, planchar:  null, lavadosec: null  },
  hcalzoncillos:    { lavadoplan:  4.01, planchar:  null, lavadosec: null  },
  hcamisetaetiq:    { lavadoplan: 10.97, planchar:  7.76, lavadosec: 11.77 },
  hcamisaopolo:     { lavadoplan:  7.22, planchar:  5.54, lavadosec:  8.56 },
  hcamiseta:        { lavadoplan:  4.54, planchar:  null, lavadosec: null  },
  hcorbata:         { lavadoplan:  5.88, planchar:  3.48, lavadosec:  7.76 },
  hchaleco:         { lavadoplan:  7.76, planchar:  5.35, lavadosec:  9.10 },
  hjersey:          { lavadoplan:  7.76, planchar:  5.35, lavadosec:  9.10 },
  hpantalón:        { lavadoplan: 10.43, planchar:  7.76, lavadosec: 10.97 },
  hpanuelo:         { lavadoplan:  2.93, planchar:  null, lavadosec: null  },
  hpijama:          { lavadoplan:  7.76, planchar:  5.35, lavadosec: null  },
  hsmoking:         { lavadoplan: 25.96, planchar: 14.18, lavadosec: 29.16 },
  htraje:           { lavadoplan: 16.36, planchar: 13.10, lavadosec: 19.53 },
}

export const prendasMujer = [
  "mabrigo",
  "malbornoz",
  "mblusapolo",
  "mblusaseda",
  "mbraguita",
  "mcombinación",
  "mchaqueta",
  "mfalda",
  "mjersey",
  "mleotardos",
  "mpantalón",
  "mpañuelo",
  "mpijama",
  "msujetador",
  "mtraje",
  "mvestido",
  "mvestidonoche",
]

export const prendasHombre = [
  "habrigo",
  "halbornoz",
  "hamericana",
  "hcalcetines",
  "hcalzoncillos",
  "hcamisetaetiq",
  "hcamiseta",
  "hcorbata",
  "hchaleco",
  "hjersey",
  "hpantalón",
  "hpanuelo",
  "hpijama",
  "hsmoking",
  "htraje",
]



// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/laundry.js